import React from 'react';

/**
 * Logo component for Auto Appraiser Assistant
 * Premium text wordmark matching app theme
 */
const Logo = ({ variant = 'default', size = 'md', className = '' }) => {
  const sizes = {
    sm: { width: 180, height: 40, title: 17, subtitle: 12 },
    md: { width: 220, height: 48, title: 20, subtitle: 14 },
    lg: { width: 280, height: 60, title: 26, subtitle: 18 },
  };

  const { width, height, title, subtitle } = sizes[size] || sizes.md;
  const uniqueId = React.useId();

  const isLight = variant === 'light';

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        {/* Gradient matching app's primary accent */}
        <linearGradient id={`${uniqueId}-accent`} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#38bdf8" />
          <stop offset="50%" stopColor="#22d3ee" />
          <stop offset="100%" stopColor="#06b6d4" />
        </linearGradient>
      </defs>

      {/* Main title - "Auto Appraiser" */}
      <text
        x="0"
        y={height * 0.42}
        fontFamily="'Poppins', 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif"
        fontSize={title}
        fontWeight="700"
        letterSpacing="-0.02em"
        fill={isLight ? '#FFFFFF' : '#051c34'}
      >
        Auto Appraiser
      </text>

      {/* Subtitle - "ASSISTANT" with gradient */}
      <text
        x="0"
        y={height * 0.85}
        fontFamily="'Poppins', 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif"
        fontSize={subtitle}
        fontWeight="600"
        letterSpacing="0.2em"
        fill={`url(#${uniqueId}-accent)`}
      >
        ASSISTANT
      </text>

      {/* Accent line under ASSISTANT */}
      <rect
        x="0"
        y={height * 0.92}
        width={subtitle * 5.5}
        height="2"
        rx="1"
        fill={`url(#${uniqueId}-accent)`}
      />
    </svg>
  );
};

export default Logo;
